import React from "react";
import { UsagesContainer, Card, CardCounter } from "./index.styled";
import microphoneIcon from "../../assets/icons/microphone.svg";
import openBookMicrophone from "../../assets/icons/open-book-microphone.svg";
import speakerIcon from "../../assets/icons/speaker.svg";
import headphonesIcon from "../../assets/icons/headphones.svg";
import { TextContainer, CardContainer } from "../../pages/landing/index.styled";
import CardItem from "../cardItem";

const Usages = () => {

  const cardItems = [
    {
      id: 1,
      content:
        "تعامل طبیعی‌تر و جذاب‌تر در چت‌بات‌ها، دستیارهای صوتی و کتابخوان‌ها",
      title: "پشتیبانی دستیار صوتی",
      icon: headphonesIcon,
      color: "#D1E6FF",
    },
    {
      id: 2,
      content:
        "خبرخوان هوشمند برای سرویس‌های خبری و رسانه‌های صوتی",
      title: "گوینده برنامه های مختلف",
      icon: microphoneIcon,
      color: "#FFF7B3",
    },
    {
      id: 3,
      content:
        "خوانش روان متون برای توانیابان مهارت‌‌های دیداری و گفتاری ",
      title: "قابل استفاده توان‌یابان",
      icon: speakerIcon,
      color: "#E2E6F9",
    },
    {
      id: 4,
      content:
        "پردازش انواع فایل‌های pdf، Word، Pages و صفحات وب آنلاین ",
      title: "خوانش انواع متن و مقالات",
      icon: openBookMicrophone,
      color: "#FFC3C3",
    },
  ];

  return (
    <UsagesContainer className="container" id="usages">
      <h2>کاربردهای آواشو</h2>
      <TextContainer>
        <p>
          آواشو یک API مبتنی بر هوش مصنوعی و یادگیری عمیق است که می‌تواند در
          نرم‌افزارها و اپلیکیشن‌ها ادغام شود. وب‌سرویس هوشمند آواشو با
          بهره‌گیری از الگوریتم‌های پیچیده زبانی و پهنای وسیعی از داده‌ها،
          متن‌های فارسی را می‌خواند و آن‌ها را به گفتار روان و طبیعی بازگو
          می‌کند. با سرویس آواشو هر توسعه‌دهنده‌ای می‌تواند امکانات برنامه خود
          را گسترش دهد و نسخه ارتقا یافته‌ و هوشمند محصول خود را ارائه دهد.
        </p>
      </TextContainer>
      <CardContainer>
        {cardItems.map((item) => (
          <CardItem key={item.id} color={item.color} cardItem={item} />
        ))}
      </CardContainer>
    </UsagesContainer>
  );
};

export default Usages;
